import { ListCardItemView } from 'components/pages/Card/sections/ListCardItemView';
import { CardItem } from 'components/pages/Card/model/types';
import { FC } from 'react';
import styles from '../Card.module.scss';

type Props = {
  cardList: CardItem[];
  handleOpenModal: (data: CardItem) => void;
  handleReceiveClick: (card: CardItem) => void;
};

export const CardListSection: FC<Props> = ({ cardList, handleOpenModal, handleReceiveClick }) => {
  return (
    <div className={styles.body}>
      <div className={styles.card}>
        {cardList.map(card => (
          <ListCardItemView
            key={card.id}
            card={card}
            handleOpenModal={handleOpenModal}
            handleReceiveClick={handleReceiveClick}
          />
        ))}
      </div>
    </div>
  );
};
